import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import { AppConfig, IAppConfig } from "../models/core/app-config";

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  private appConfig: IAppConfig = new AppConfig(); 
  configLoaded: boolean = false;
  private configFetching: boolean = false;
  private appConfigLoadedSource = new Subject<IAppConfig>();
  private appConfigLoaded$: Observable<IAppConfig> = this.appConfigLoadedSource.asObservable();

  constructor(private http: HttpClient) {}

  getAppConfig(): Observable<IAppConfig> {
    if (!this.configLoaded) {
      if(this.configFetching){
        return this.appConfigLoaded$;
      }
      
      this.loadAppConfig();
      return this.appConfigLoaded$;
    }
    return of(this.appConfig);
  }

  loadAppConfig() {
    this.configFetching = true;
      this.http.get<IAppConfig>("assets/config/appConfig.json").
      subscribe(data => { 
          this.appConfig = data; 
          this.appConfigLoadedSource.next(data);
          this.configLoaded = true;
          this.configFetching = false;
      });
  }

  getLoadedConfig() {
    return this.appConfig;
  }
}
